export const fetchCustomerLabels = () => ({
  type: 'CUSTOMER_LABELS_FETCH_REQUEST'
})